import { render } from "./Seniortitla.vue?vue&type=template&id=4bd7064b&scoped=true"
import script from "./Seniortitla.vue?vue&type=script&lang=js"
export * from "./Seniortitla.vue?vue&type=script&lang=js"

import "./Seniortitla.vue?vue&type=style&index=0&id=4bd7064b&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd7064b"]])

export default __exports__